// extracted by mini-css-extract-plugin
export default {"container":"kI-z","header":"lI-z","details":"mI-z","link":"nI-z"};